module.exports = __webpack_public_path__ + "img/exclemation-mark-yellow.512bc091.svg";